/* paris-box.js - the Paris box of sections/paris-box.liquid (V13).

   Without this file each pick is a plain add-to-bag form and the panel stays
   hidden (.no-js). With it, a pick's submit toggles it in and out of the box
   instead, the panel's slots show the chosen packshots in order, the panel
   totals the picks at the shelf price and says how far the store's free US
   shipping line is, and the panel's button posts every pick at once to
   /cart/add.js (items[]), asks for the cart drawer section on the way, and
   opens the drawer on the answer, the same path assets/quick-add.js takes.
   A card of the set taken out of the box is marked --out (its picture dims)
   until it is put back, except right after an add, when the box is empty on
   purpose.

   THE SET. Picks marked data-box-default by the section start in the box, so
   the first state is four picks and "Add all 4 to bag". The section already
   rendered that state, button enabled, so nothing moves when this runs.

   THE SWAP ON A FULL BOX. A swap row's toggle gives way to its [data-box-swap]
   button, which opens a chooser in that row: the picks in the box as pictures.
   A row near the bottom edge would open it off screen, so the page then
   scrolls just enough to show it. Pressing one replaces it IN PLACE (same
   slot), so a swap is three taps with the add, all of them below the button. A fifth pick from a set card is still
   refused out loud: that toggle says the box is full, aria-disabled.

   THE BUTTON STAYS REACHABLE. When a tap on a swap row fills the box again and
   the button is off screen or under the header at its tallest (the pinned
   header section plus --pp-header-height, which header.js keeps equal to the
   expanded height), the page is scrolled once so that the button sits just
   under that header. Smooth unless the shopper asked for reduced motion.

   THE SET CODE, the fallback of the set price: the section renders
   data-box-code only while data-set-amount is 0, and a code is ignored here
   whenever data-set-amount is above 0 (as rendered), so the two never run
   together. When the section
   carries data-box-code and the whole box was added, the code is applied
   with ONE POST /cart/update.js `discount`, the pattern of Horizon's
   assets/cart-discount.js. That field REPLACES the cart's code list, so
   every code the cart already holds, applicable or not, is posted with it; they are read from the cart itself, one GET /cart.js after
   the add, never from the drawer markup (it prints a remove button for the
   applicable codes only, so a code it does not show would be wiped). When
   that read fails, no update.js is sent at all and the outcome is failed. The
   JSON answer of update.js is the only source of the outcome:
   discount_codes[].applicable for this code, and total_discount, the only
   money printed after the add (and only when a code is set). A refused or
   failed code never undoes the add.

   WHILE AN ADD IS IN FLIGHT the box is frozen: the set and the swap rows are
   inert and every handler returns on `busy`, so what the bag receives is
   exactly what the box showed when the button was pressed. The button keeps
   focus (aria-disabled, not disabled) and gets it back after a failed add.
   AN EMPTY BOX IS aria-disabled TOO, NEVER disabled. After an add the box
   is empty on purpose while the drawer opens, and the button that was
   pressed is the drawer's way back: assets/cart-drawer.js returns focus to
   the control that opened it. A disabled button drops focus to the body
   and cannot take it back, so a keyboard or screen reader user closing the
   drawer landed nowhere. add() refuses an empty or busy box itself.

   A 422 FROM /cart/add.js names what could not go in, and Shopify may still
   have added what stock allowed. One GET /cart.js makes the page true again
   (the drawer is repainted when the count moved), compared by quantity with
   the bag before the press as the latest GET /cart.js of this file saw it
   (a read still in flight at the press is waited for, READ_WAIT at most;
   the drawer's lines, which can lag behind the cart, only when no read ever
   answered or the one in flight hangs past that): a pick
   whose quantity grew went in and
   leaves the box, so it is never posted twice, even one the bag already
   held. The refused pick is the one the description names by title; else
   the only one that did not go in while the others did; else, for a
   quantity message (Shopify's no longer carry the name) with nothing gone
   in, the only pick the cart already held. It leaves the box, is marked,
   cannot be put back this visit, and the error line names it, adding "Pick
   one more." only when 3 of 4 are left. When something went in, the message
   line says it was added. When none of these holds, the error is the plain
   one and the box is unchanged. Focus goes back to the button, or to the
   error line when the box is left empty.
   The error line is always in the markup, below the button, but out of the
   flow until the first press, so there is no blank under the button at rest.
   The press itself (same task, before add.js) puts it in the flow with the
   height of the tallest message it can show at the current width (measured
   on a hidden copy, again when the width changes and when the fonts load;
   the measures at load and at fonts.ready wait for an idle moment, so they
   force no layout while the page is still loading, and a press that comes
   first measures on the spot): that move falls inside the input's 500 ms and does not count as a layout
   shift, and from then on showing or clearing a message moves nothing. The
   reserve stays until the page is reloaded.

   THE SET PRICE (data-set-amount, cents, 0 = off). With every slot filled the
   total is printed twice: the sum of the picks minus that fixed amount in the
   sale red, then the sum struck; with fewer picks, the sum alone and the line
   that says what four would save. The free shipping line counts from the
   total the box shows. Never a percentage: see sections/paris-box.liquid.
   THE MONEY DECIDES, NOT THE LABELS. What the set's discount put in the bag
   is read from the cart, never from a discount's type, value type, method
   or title: the sum of the line level allocations (Ajax cart JSON
   items[].line_level_discount_allocations[].amount, presentment cents;
   line_level_total_discount when a line has no such array) on the
   collection's one-time lines (gotOf). It is applied when that sum reaches
   the set amount, less 1 cent (2% off a converted amount). A cart level
   application never counts: items[].discounts and items[].total_discount
   also carry the share of an order discount, and any other ~$10 off the
   order would pass for the set's.
   After an add of the whole box, one GET /cart.js makes that check
   (checkSet); the add itself does not wait for it. Applied, the message
   line adds the set saving to "Added to your bag.", kept apart (doneSaved)
   and printed only while the set and its money are still in the bag, so a
   drawer removal or a page show from the cache takes the claim away with
   the line; short of it,
   pp:box:discount_missing is dispatched, and nothing else changes: the set
   price stays as the section printed it. The 24 hour switch-off of V13
   (localStorage pp:box:set-off) is gone, and its key is removed at load.
   ONCE PER ORDER: while the cart holds data-set-min items of the collection's
   products (data-set-products, matched on each line's product_id) bought
   once (a subscription line, one with a selling_plan_allocation, is not
   counted: the discount is one-time purchase only), the discount is spent
   and the box shows the full price, no red, no save line; when the money
   above is in the bag (data-set-got at render, then every cart read), the
   applied line [data-box-applied] says so instead. Liquid counts it
   at render (data-set-held); this file counts it again from GET /cart.js
   when the element connects, on a page show from the back and forward
   cache, after every add (the same GET as the check above, or the one a 422
   already makes), and on every cartUpdate another surface publishes (a quick
   add, a drawer change). Each read carries a number and only the latest one
   started is applied; an add starts a new number too, so a read that left
   before it cannot put the old count back. These reads run whatever
   data-set-amount says: the answer they apply is also the bag the next add
   is compared with after a 422 (see above).

   TRACKING. Each button's first data attribute, data-box-action, names what a
   press does NOW (add_item, remove_item, full, refused, swap_open, swap_out,
   swap_close, add_all, add_some); pp-interactions reads it at capture, before
   this file flips it. The theme bus keeps the V9b shape, cartUpdate or
   cartError with source paris-box. With data-box-events on the element, two
   DOM events bubble from it for pp-ux:
     pp:box:pick  { h: product handle, on: bool, cnt: picks after the change,
                    pre: bool, the product was in the preselected set }
                  once per change; a swap is one `on: false` then one `on: true`.
     pp:box:add   { ok: bool, cnt: picks posted, whole: bool, all slots filled,
                    swaps: picks posted that were not preselected,
                    code: none | applied | refused | failed,
                    disc: bool, a line this box added carries a discount in the
                    last cart JSON (or the code applied with a cart discount) }
                  once, after the add and the code are settled.
     pp:box:discount_missing { amt: the set amount, cnt: picks posted,
                    got: line level discount on the collection's one-time
                    lines in that cart, all in cents }
                  once, after an add of the whole box with a set price, when
                  got is short of amt (see THE MONEY DECIDES).

   Every word shown comes from a data-str-* attribute on the section, so the
   merchant owns the copy and none of it ships here. Money is formatted with
   Intl in the cart's currency; the threshold arrives in the shop currency and
   is converted with Shopify's presentment rate. */
(() => {
  if (window.customElements.get('pp-paris-box')) return;

  const pp = () => window.PP || {};
  const root = () => (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  const still = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* How long a press waits for a cart read in flight (see the header): a
     read that hangs costs the precision of a 422 message, never the add. */
  const READ_WAIT = 1500;
  /* The V13 switch-off key, never read any more: a browser that still holds
     one gets the set price back on this load (see the header). */
  try {
    window.localStorage.removeItem('pp:box:set-off');
  } catch (e) {
    /* No storage: nothing to clear. */
  }

  class ParisBox extends HTMLElement {
    connectedCallback() {
      if (this.armed) return;
      this.armed = true;
      this.slots = parseInt(this.dataset.slots, 10) || 4;
      const rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
      this.threshold = Math.round((parseInt(this.dataset.threshold, 10) || 0) * rate);
      this.rate = rate;
      this.setAmount = Math.max(0, Math.round((parseInt(this.dataset.setAmount, 10) || 0) * rate));
      this.setMin = parseInt(this.dataset.setMin, 10) || this.slots;
      this.setHeld = parseInt(this.dataset.setHeld, 10) || 0;
      this.setGot = parseInt(this.dataset.setGot, 10) || 0;
      this.setProducts = new Set(String(this.dataset.setProducts || '').split(',').filter(Boolean));
      try {
        this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
      } catch (e) {
        this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      }
      /* Whole amounts without the cents, as money_without_trailing_zeros. */
      this.moneyWhole = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.money.resolvedOptions().currency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
      this.picks = [];
      this.doneSaved = '';
      this.refused = new Set();
      this.panel = this.querySelector('[data-box-panel]');
      this.addButton = this.querySelector('[data-box-add]');
      this.error = this.querySelector('[data-box-error]');
      this.setPrice = this.querySelector('[data-box-set]');
      this.setTotal = this.querySelector('[data-box-set-total]');
      this.saveLine = this.querySelector('[data-box-save]');
      this.appliedLine = this.querySelector('[data-box-applied]');
      this.toggles = [...this.querySelectorAll('[data-box-toggle]')];
      this.toggles.forEach((toggle) => {
        toggle.setAttribute('aria-pressed', 'false');
        toggle.type = 'button';
        if (toggle.hasAttribute('data-box-default') && this.picks.length < this.slots) this.picks.push(this.pickOf(toggle));
      });
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.chooser) {
          event.preventDefault();
          this.closeChooser(true);
        }
      });
      this.addEventListener('submit', (event) => event.preventDefault());
      this.panel.hidden = false;
      this.render();
      /* Layout reads, off the load path (see the header). */
      const idle = (fn) => (window.requestIdleCallback ? window.requestIdleCallback(fn, { timeout: 2000 }) : window.setTimeout(fn, 200));
      idle(() => this.reserveError());
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => idle(() => this.reserveError()));
      let width = window.innerWidth;
      let timer = 0;
      window.addEventListener('resize', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (window.innerWidth === width) return;
          width = window.innerWidth;
          this.reserveError();
        }, 150);
      });
      this.readSeq = 0;
      this.cartHeld = null;
      this.reading = null;
      this.readSet();
      window.addEventListener('pageshow', (event) => {
        if (event.persisted && this.isConnected) this.readSet();
      });
      /* Another surface changed the cart. During this box's own add the
         drawer's repaint says so too; the add reads the cart itself once it
         has settled, so that echo is left to it. */
      if (pp().subscribe && pp().EVENTS) {
        pp().subscribe(pp().EVENTS.cartUpdate, (detail) => {
          if ((detail && detail.source) === 'paris-box' || this.busy || !this.isConnected) return;
          this.readSet();
        });
      }
    }

    /* The set price is spent for this order (see the header). */
    setUsed() {
      return this.setHeld >= this.setMin;
    }

    /* The collection's items bought once in one /cart.js answer. A line with
       a selling_plan_allocation is a subscription, which the one-time
       purchase discount skips, so it is not counted (as in the section). */
    heldOf(cart) {
      return (cart.items || []).reduce((n, line) => n + (!line.selling_plan_allocation && this.setProducts.has(String(line.product_id)) ? Number(line.quantity) || 0 : 0), 0);
    }

    /* Cents of line level discount on the same lines (plus the variants
       `ids` just posted), any type or value type (see THE MONEY DECIDES). */
    gotOf(cart, ids) {
      return (cart.items || []).reduce((n, line) => {
        if (line.selling_plan_allocation) return n;
        if (!this.setProducts.has(String(line.product_id)) && !(ids && ids.includes(Number(line.variant_id)))) return n;
        const allocations = line.line_level_discount_allocations;
        const cents = Array.isArray(allocations)
          ? allocations.reduce((s, a) => s + (Number(a && a.amount) || 0), 0)
          : Number(line.line_level_total_discount) || 0;
        return n + cents;
      }, 0);
    }

    /* The bag carries the set's money: got at least the amount, less 1 cent,
       or 2% when the amount was converted to another currency. */
    applied(got) {
      const slack = this.rate === 1 ? 1 : Math.ceil(this.setAmount * 0.02);
      return this.setAmount > 0 && got >= this.setAmount - slack;
    }

    async readCart() {
      try {
        const res = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
        return res.ok ? await res.json() : null;
      } catch (e) {
        return null;
      }
    }

    /* Quantity per variant id in one /cart.js answer. */
    quantities(cart) {
      const held = new Map();
      (cart.items || []).forEach((line) => held.set(String(line.variant_id), (held.get(String(line.variant_id)) || 0) + (Number(line.quantity) || 0)));
      return held;
    }

    /* What the cart holds now: the set count and the bag the next add is
       compared with (see the header). A cart that cannot be read leaves both
       as they were, and a read overtaken by a later one or by an add leaves
       them to it. `reading` lets a press wait for a read in flight. */
    readSet() {
      const seq = ++this.readSeq;
      const run = this.readCart().then((cart) => {
        if (!cart || seq !== this.readSeq) return;
        this.cartHeld = this.quantities(cart);
        this.setHeld = this.heldOf(cart);
        this.setGot = this.gotOf(cart);
        this.render();
      });
      this.reading = run;
      run.then(() => {
        if (this.reading === run) this.reading = null;
      });
      return run;
    }

    str(name) {
      return this.getAttribute('data-str-' + name) || '';
    }

    format(cents) {
      return this.money.format(cents / 100);
    }

    formatShort(cents) {
      return cents % 100 === 0 ? this.moneyWhole.format(cents / 100) : this.format(cents);
    }

    pickOf(button) {
      const card = button.closest('.paris-box__pick');
      const name = card && card.querySelector('.paris-box__name');
      return {
        id: button.dataset.variant,
        price: parseInt(button.dataset.price, 10) || 0,
        handle: button.dataset.handle || '',
        pre: button.hasAttribute('data-box-default'),
        name: name ? name.textContent.trim() : '',
        title: button.dataset.title || '',
        img: card && card.querySelector('[data-box-image]')
      };
    }

    toggleOf(id) {
      return this.toggles.find((toggle) => toggle.dataset.variant === id);
    }

    emit(type, detail) {
      if (!this.hasAttribute('data-box-events')) return;
      this.dispatchEvent(new CustomEvent(type, { bubbles: true, detail }));
    }

    picked(pick, on) {
      this.emit('pp:box:pick', { h: pick.handle, on, cnt: this.picks.length, pre: pick.pre });
    }

    onClick(event) {
      const t = event.target;
      const toggle = t.closest('[data-box-toggle]');
      if (toggle) {
        event.preventDefault();
        this.toggle(toggle);
        return;
      }
      const swap = t.closest('[data-box-swap]');
      if (swap) {
        this.openChooser(swap);
        return;
      }
      const out = t.closest('[data-box-swap-out]');
      if (out) {
        this.swap(out);
        return;
      }
      if (t.closest('[data-box-swap-close]')) {
        this.closeChooser(true);
        return;
      }
      if (t.closest('[data-box-add]')) this.add();
    }

    toggle(button) {
      if (this.busy) return;
      const id = button.dataset.variant;
      const at = this.picks.findIndex((pick) => pick.id === id);
      if (at === -1 && this.refused.has(id)) return;
      this.clearError();
      this.done = '';
      this.doneSaved = '';
      this.closeChooser(false);
      let pick;
      if (at > -1) {
        pick = this.picks.splice(at, 1)[0];
      } else {
        if (this.picks.length >= this.slots) {
          this.render(true);
          return;
        }
        pick = this.pickOf(button);
        this.picks.push(pick);
      }
      this.render();
      this.picked(pick, at === -1);
      if (at === -1 && this.picks.length >= this.slots && !pick.pre) this.reveal();
    }

    /* The chooser is built here from the picks, so it always shows the box as
       it is now; the row only holds its empty, hidden container. */
    openChooser(swap) {
      if (this.busy) return;
      const row = swap.closest('.paris-box__pick');
      const box = row && row.querySelector('[data-box-chooser]');
      if (!box) return;
      const again = this.chooser === box;
      this.closeChooser(false);
      if (again) return;
      const incoming = row.querySelector('[data-box-toggle]');
      const prompt = document.createElement('p');
      prompt.id = box.id + '-prompt';
      prompt.textContent = this.str('swap-prompt');
      box.setAttribute('role', 'group');
      box.setAttribute('aria-labelledby', prompt.id);
      box.replaceChildren(prompt);
      this.picks.forEach((pick) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'paris-box__out';
        b.setAttribute('data-box-action', 'swap_out');
        b.setAttribute('data-box-swap-out', pick.id);
        b.setAttribute('data-box-swap-in', incoming ? incoming.dataset.variant : '');
        b.setAttribute('aria-label', this.str('swap-out').replace('[name]', pick.name));
        if (pick.img) {
          const img = document.createElement('img');
          img.src = pick.img.currentSrc || pick.img.src;
          img.alt = '';
          b.append(img);
        }
        box.append(b);
      });
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'paris-box__close';
      close.setAttribute('data-box-action', 'swap_close');
      close.setAttribute('data-box-swap-close', '');
      close.setAttribute('aria-label', this.str('swap-close'));
      const icon = this.querySelector('template[data-box-close-icon]');
      if (icon) close.append(icon.content.cloneNode(true));
      box.append(close);
      box.hidden = false;
      swap.setAttribute('aria-expanded', 'true');
      this.chooser = box;
      const r = box.getBoundingClientRect();
      if (r.bottom > window.innerHeight - 12) {
        window.scrollBy({ top: r.bottom - window.innerHeight + 12, behavior: still() ? 'auto' : 'smooth' });
      }
      const first = box.querySelector('[data-box-swap-out]');
      if (first) first.focus({ preventScroll: true });
    }

    closeChooser(refocus) {
      const box = this.chooser;
      if (!box) return;
      this.chooser = null;
      box.hidden = true;
      box.replaceChildren();
      const row = box.closest('.paris-box__pick');
      const swap = row && row.querySelector('[data-box-swap]');
      if (swap) {
        swap.setAttribute('aria-expanded', 'false');
        if (refocus) swap.focus({ preventScroll: true });
      }
    }

    swap(out) {
      if (this.busy) return;
      const at = this.picks.findIndex((pick) => pick.id === out.getAttribute('data-box-swap-out'));
      const incoming = this.toggleOf(out.getAttribute('data-box-swap-in'));
      this.closeChooser(false);
      if (at === -1 || !incoming || this.picks.some((pick) => pick.id === incoming.dataset.variant)) return;
      this.clearError();
      this.done = '';
      this.doneSaved = '';
      const leaving = this.picks[at];
      const coming = this.pickOf(incoming);
      this.picks.splice(at, 1);
      this.picked(leaving, false);
      this.picks.splice(at, 0, coming);
      this.render();
      this.picked(coming, true);
      incoming.focus({ preventScroll: true });
      this.reveal();
    }

    /* Where the pinned header ends at its tallest: its section's top (0 once
       pinned) plus the height header.js publishes, which is the expanded one.
       An unpinned header scrolls away and covers nothing. */
    covered() {
      const section = document.querySelector('.header-section.header-sticky');
      if (!section) return 0;
      const height = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pp-header-height')) || 0;
      return Math.max(0, section.getBoundingClientRect().top) + height;
    }

    reveal() {
      const r = this.addButton.getBoundingClientRect();
      const top = this.covered() + 12;
      if (r.top >= top && r.bottom <= window.innerHeight - 12) return;
      window.scrollBy({ top: r.top - top, behavior: still() ? 'auto' : 'smooth' });
    }

    total() {
      return this.picks.reduce((sum, pick) => sum + pick.price, 0);
    }

    render(full) {
      const total = this.total();
      const count = this.picks.length;

      this.querySelectorAll('[data-box-slot]').forEach((slot, i) => {
        const pick = this.picks[i];
        const shown = slot.getAttribute('data-id') || '';
        if ((pick ? pick.id : '') === shown) return;
        slot.setAttribute('data-id', pick ? pick.id : '');
        slot.classList.toggle('paris-box__slot--full', !!pick);
        slot.replaceChildren();
        if (pick && pick.img) {
          const img = document.createElement('img');
          img.src = pick.img.currentSrc || pick.img.src;
          img.alt = pick.img.alt;
          slot.append(img);
        } else {
          const n = document.createElement('span');
          n.textContent = String(i + 1);
          slot.append(n);
        }
      });

      this.toggles.forEach((button) => {
        const on = this.picks.some((pick) => pick.id === button.dataset.variant);
        const refused = !on && this.refused.has(button.dataset.variant);
        const blocked = !on && !refused && count >= this.slots;
        const card = button.closest('.paris-box__pick');
        const swap = card && card.querySelector('[data-box-swap]');
        /* A swap row on a full box offers the swap instead of a dead toggle. */
        if (swap) {
          swap.hidden = !blocked;
          button.closest('form').hidden = blocked;
          if (!blocked) swap.setAttribute('aria-expanded', 'false');
        }
        button.setAttribute('data-box-action', on ? 'remove_item' : refused ? 'refused' : blocked ? 'full' : 'add_item');
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (blocked || refused) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
        const label = button.querySelector('[data-box-toggle-label]');
        if (label) label.textContent = on ? this.str('in') : refused ? this.str('refused') : blocked ? this.str('full') : this.str('add');
        if (card) {
          card.classList.toggle('paris-box__pick--refused', refused);
          card.classList.toggle('paris-box__pick--in', on);
          card.classList.toggle('paris-box__pick--out', !on && !this.done && button.hasAttribute('data-box-default'));
        }
      });

      this.querySelector('[data-box-count]').textContent = this.str('count')
        .replace('[count]', String(count))
        .replace('[slots]', String(this.slots));
      this.querySelector('[data-box-total]').textContent = this.format(total);

      /* The set price: see the header. `shown` is the total the box prints. */
      const set = this.setAmount > 0 && !this.setUsed();
      const discounted = set && count >= this.slots;
      const shown = discounted ? Math.max(0, total - this.setAmount) : total;
      if (this.setPrice) {
        this.setPrice.hidden = !discounted;
        if (discounted) this.setTotal.textContent = this.format(shown);
      }
      this.querySelector('[data-box-total]').classList.toggle('paris-box__total--was', discounted);
      if (this.saveLine) {
        this.saveLine.hidden = !set;
        this.saveLine.classList.toggle('paris-box__save--pick', !discounted);
        this.saveLine.textContent = this.str(discounted ? 'set-save' : 'set-pick').replace('[amount]', this.formatShort(this.setAmount));
      }
      /* The set is spent and its money is in the bag: said, not left to a
         plain full price (see the header). */
      if (this.appliedLine) {
        const text = this.str('set-applied');
        const said = this.setUsed() && this.applied(this.setGot) && !!text;
        this.appliedLine.hidden = !said;
        if (said) this.appliedLine.textContent = text.replace('[amount]', this.formatShort(this.setAmount));
      }

      const ok = this.threshold > 0 && shown >= this.threshold;

      const msg = this.querySelector('[data-box-msg]');
      msg.classList.toggle('paris-box__msg--ok', ok && count > 0);
      if (full) {
        msg.textContent = this.str('full');
      } else if (!count && this.done) {
        /* The set saving is said only while it holds (see the header). */
        const saved = this.doneSaved && this.setUsed() && this.applied(this.setGot);
        msg.textContent = saved ? this.done + ' ' + this.doneSaved : this.done;
      } else if (!count) {
        msg.textContent = this.str('empty');
      } else if (ok) {
        msg.textContent = this.str('ok');
      } else {
        const [before, after] = this.str('left').split('[amount]');
        const amount = document.createElement('b');
        amount.textContent = this.format(this.threshold - shown);
        msg.replaceChildren(before || '', amount, after || '');
      }

      const all = !count || count >= this.slots;
      this.addButton.setAttribute('data-box-action', count >= this.slots ? 'add_all' : 'add_some');
      /* Busy and empty are aria-disabled only (see the header): the button
         keeps focus through the add and after it. */
      this.addButton.disabled = false;
      if (!count || this.busy) this.addButton.setAttribute('aria-disabled', 'true');
      else this.addButton.removeAttribute('aria-disabled');
      this.querySelectorAll('.paris-box__set, .paris-box__alts').forEach((el) => {
        el.inert = !!this.busy;
      });
      this.querySelector('[data-box-button]').textContent = this.str(all ? 'all' : 'some')
        .replace('[slots]', String(this.slots))
        .replace('[count]', String(count));
    }

    drawer() {
      return document.querySelector('[data-cart-drawer]');
    }

    drawerSection() {
      const drawer = this.drawer();
      return (drawer && drawer.getAttribute('data-section-id')) || '';
    }

    /* Called once the add has landed and been reported, so nothing the drawer
       does may reach add()'s catch: a paint or an open that throws (a
       showModal() on a dialog already open is an InvalidStateError) would
       report a second, failed add of picks already in the bag and invite the
       shopper to buy the set again. show() swallows it, as in
       assets/product-pack.js; the message line already says they were added. */
    openDrawer(html) {
      const show = () => {
        try {
          if (html && typeof pp().paintCartSection === 'function') pp().paintCartSection(html);
          if (pp().openCartDrawer) pp().openCartDrawer();
        } catch (e) {
          /* The drawer is lost, the add is not. */
        }
      };
      if (pp().openCartDrawer) {
        show();
        return;
      }
      const drawer = this.drawer();
      const src = drawer && drawer.getAttribute('data-cart-drawer-js');
      /* A drawer module that does not load (or throws) costs the drawer,
         never the add: the bag holds the picks, the message line already
         says they were added, and the box is empty, so add() refuses a
         second press. Nothing is left to an unhandled rejection. */
      if (src && pp().loadModule) pp().loadModule(src).then(show).catch(() => {});
      else window.location.assign(root() + 'cart');
    }

    async post(path, body) {
      const section = this.drawerSection();
      if (section) {
        body.sections = section;
        body.sections_url = window.location.pathname;
      }
      const res = await fetch(root() + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const payload = await res.json().catch(() => null);
      if (!res.ok || !payload) {
        const error = new Error((payload && payload.description) || String(res.status));
        error.status = res.status;
        error.description = (payload && payload.description) || '';
        throw error;
      }
      return { json: payload, html: (payload.sections && payload.sections[section]) || null };
    }

    /* Every code on the cart, applicable or not, as the cart itself holds
       them: update.js `discount` replaces the list, so a code left out here is
       removed from the shopper's cart. Throws when the cart cannot be read,
       and the caller then sends no update.js. */
    async cartCodes() {
      const res = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error(String(res.status));
      const cart = await res.json();
      const list = [];
      (cart.discount_codes || []).forEach((c) => {
        const name = c && c.code ? String(c.code) : '';
        if (name && !list.some((x) => x.code.toUpperCase() === name.toUpperCase())) list.push({ code: name, applicable: c.applicable === true });
      });
      return list;
    }

    async add() {
      if (!this.picks.length || this.busy) return;
      this.armError();
      const posted = this.picks.slice();
      const ids = posted.map((pick) => Number(pick.id));
      const whole = posted.length >= this.slots;
      const code = (parseInt(this.dataset.setAmount, 10) || 0) > 0 ? '' : (this.dataset.boxCode || '').trim();
      const outcome = {
        ok: false,
        cnt: posted.length,
        whole,
        swaps: posted.filter((pick) => !pick.pre).length,
        code: 'none',
        disc: false
      };
      this.busy = true;
      this.clearError();
      this.done = '';
      this.doneSaved = '';
      this.closeChooser(false);
      this.addButton.setAttribute('aria-busy', 'true');
      this.render();
      /* The bag before this add, for a 422 (see the header). The box is
         frozen while a read in flight lands, READ_WAIT at most; past it the
         drawer's lines stand in, and the late read is discarded by readSeq. */
      let timer = 0;
      const fresh = !this.reading || await Promise.race([
        this.reading.then(() => true, () => true),
        new Promise((resolve) => {
          timer = setTimeout(resolve, READ_WAIT, false);
        })
      ]);
      clearTimeout(timer);
      const before = (fresh && this.cartHeld) || this.heldQuantities();
      this.readSeq += 1;
      let failed = false;
      let checkSet = false;
      let done = '';
      try {
        const added = await this.post('cart/add.js', { items: ids.map((id) => ({ id, quantity: 1 })) });
        let html = added.html;
        let lines = Array.isArray(added.json.items) ? added.json.items : [];
        let saved = 0;
        if (whole && code) {
          try {
            const codes = await this.cartCodes();
            const held = codes.find((c) => c.code.toUpperCase() === code.toUpperCase());
            if (held) {
              outcome.code = held.applicable ? 'applied' : 'refused';
            } else {
              const updated = await this.post('cart/update.js', { discount: codes.map((c) => c.code).concat(code).join(',') });
              const cart = updated.json;
              const entry = (cart.discount_codes || []).find((c) => String(c.code).toUpperCase() === code.toUpperCase());
              outcome.code = entry && entry.applicable === true ? 'applied' : 'refused';
              html = updated.html || html;
              if (Array.isArray(cart.items)) lines = cart.items.filter((line) => ids.includes(Number(line.variant_id)));
              saved = cart.total_discount > 0 ? cart.total_discount : 0;
              if (outcome.code === 'applied' && saved) outcome.disc = true;
            }
          } catch (e) {
            /* The bag holds the four either way; the drawer shows what applied. */
            outcome.code = 'failed';
          }
        }
        if (lines.some((line) => (line.total_discount || line.line_level_total_discount || 0) > 0)) outcome.disc = true;
        outcome.ok = true;
        if (whole && this.setAmount > 0 && !this.setUsed()) checkSet = true;
        /* Every pick is a product of the collection: counted now so the save
           line does not flash back before the cart read below corrects it. */
        if (this.setAmount > 0) this.setHeld += posted.length;
        if (pp().publish && pp().EVENTS) pp().publish(pp().EVENTS.cartUpdate, { source: 'paris-box' });
        this.emit('pp:box:add', outcome);
        this.picks = [];
        this.done = this.str('added') + (code && saved ? ' ' + this.str('saved').replace('[amount]', this.format(saved)) : '');
        done = this.done;
        this.openDrawer(html);
      } catch (e) {
        failed = true;
        const settled = e && e.status === 422 ? await this.settle(e.description, posted, before) : { named: null, landed: [] };
        if (pp().publish && pp().EVENTS) pp().publish(pp().EVENTS.cartError, { source: 'paris-box' });
        this.emit('pp:box:add', outcome);
        if (settled.landed.length) this.done = this.str('added');
        const named = settled.named;
        this.showError(named ? this.itemError(named.name, this.picks.length === this.slots - 1) : this.str('error'));
      } finally {
        this.busy = false;
        this.addButton.removeAttribute('aria-busy');
        this.render();
        if (failed) (this.picks.length ? this.addButton : this.error).focus({ preventScroll: true });
      }
      if (!failed) {
        /* One read after the add: the bag for the next add, the count for the
           set price, and the check of the discount when the set price was
           shown. A cart that cannot be read proves nothing and says nothing. */
        const seq = ++this.readSeq;
        const cart = await this.readCart();
        if (cart) {
          if (seq === this.readSeq) {
            this.cartHeld = this.quantities(cart);
            this.setHeld = this.heldOf(cart);
            this.setGot = this.gotOf(cart);
            this.render();
          }
          if (checkSet) this.checkSet(cart, ids, done);
        }
      }
    }

    /* After an add of the whole box with a set price (see THE MONEY DECIDES
       in the header): the line level discount on the collection's one-time
       lines of this cart, whatever its type, value type or method, against
       the set amount. Applied: the message line of this add, when it still
       shows, says what the set saved (doneSaved, printed by render only while
       the set and its money stay in the bag). Short: pp:box:discount_missing,
       and nothing else; the set price stays. */
    checkSet(cart, ids, done) {
      const got = this.gotOf(cart, ids);
      if (this.applied(got)) {
        const saved = this.str('set-saved');
        if (saved && done && this.done === done && !this.picks.length) {
          this.doneSaved = saved.replace('[amount]', this.formatShort(this.setAmount));
          this.render();
        }
        return;
      }
      this.emit('pp:box:discount_missing', { amt: this.setAmount, cnt: ids.length, got });
    }

    itemError(name, oneLeft) {
      const next = oneLeft ? this.str('next') : '';
      return this.str('error-item').replace('[name]', name) + (next ? ' ' + next : '');
    }

    /* After a 422 (see the header): one GET /cart.js against `before`, the
       quantity per variant the bag held before the press. Picks that
       went in and the refused pick leave the box without a pp:box:pick: the
       shopper did not take them out. */
    async settle(description, posted, before) {
      const text = String(description || '');
      let named = posted.find((pick) => pick.title && text.includes(pick.title)) || null;
      let landed = [];
      try {
        const seq = ++this.readSeq;
        const res = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
        const cart = res.ok ? await res.json() : null;
        if (cart) {
          const held = this.quantities(cart);
          if (seq === this.readSeq) {
            this.cartHeld = held;
            this.setHeld = this.heldOf(cart);
            this.setGot = this.gotOf(cart);
          }
          const was = (pick) => before.get(pick.id) || 0;
          landed = posted.filter((pick) => (held.get(pick.id) || 0) > was(pick));
          if (!named) {
            const missing = posted.filter((pick) => !landed.includes(pick));
            const kept = missing.filter((pick) => was(pick) > 0);
            if (missing.length === 1 && landed.length === posted.length - 1) named = missing[0];
            else if (!landed.length && kept.length === 1 && /cart/i.test(text)) named = kept[0];
          }
          const drawer = this.drawer();
          if (drawer && String(cart.item_count) !== drawer.getAttribute('data-cart-item-count')) await this.repaint();
        }
      } catch (e) {
        /* The message still names what the description named. */
      }
      if (named) this.refused.add(named.id);
      const gone = new Set(landed.map((pick) => pick.id).concat(named ? [named.id] : []));
      this.picks = this.picks.filter((pick) => !gone.has(pick.id));
      return { named, landed };
    }

    /* Quantity per variant id of the drawer's lines, i.e. what the bag held at
       its last paint, the fallback of the latest cart read (see the header)
       when none ever answered: snippets/cart-line.liquid keys a line
       "<variant id>:<hash>" and prints its quantity in the value attribute of
       its quantity field (1 when a line has none). */
    heldQuantities() {
      const drawer = this.drawer();
      const lines = drawer ? drawer.querySelectorAll('[data-cart-line][data-line-key]') : [];
      const held = new Map();
      lines.forEach((line) => {
        const id = String(line.getAttribute('data-line-key')).split(':')[0];
        const field = line.querySelector('[data-quantity-field]');
        const quantity = (field && parseInt(field.getAttribute('value'), 10)) || 1;
        held.set(id, (held.get(id) || 0) + quantity);
      });
      return held;
    }

    /* The height of the tallest message the error line can show at this width
       (the plain error, or the item message with any product's name and the
       one-more hint), measured on a hidden copy outside the flow at the
       panel's content width, so the live region never changes. Applied only
       once the line is armed (armError). */
    reserveError() {
      const el = this.error;
      const panel = el ? window.getComputedStyle(this.panel) : null;
      const width = panel ? this.panel.clientWidth - parseFloat(panel.paddingLeft) - parseFloat(panel.paddingRight) : 0;
      if (!(width > 0)) return;
      const probe = el.cloneNode(false);
      ['role', 'id', 'tabindex', 'data-box-error', 'style'].forEach((name) => probe.removeAttribute(name));
      probe.setAttribute('aria-hidden', 'true');
      probe.setAttribute('data-armed', '');
      probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;width:' + width + 'px';
      el.after(probe);
      const names = this.toggles.map((button) => {
        const card = button.closest('.paris-box__pick');
        const name = card && card.querySelector('.paris-box__name');
        return name ? name.textContent.trim() : '';
      });
      let tallest = 0;
      [this.str('error')].concat(names.filter(Boolean).map((name) => this.itemError(name, true))).forEach((text) => {
        probe.textContent = text;
        tallest = Math.max(tallest, probe.getBoundingClientRect().height);
      });
      probe.remove();
      if (tallest) this.errorReserve = Math.ceil(tallest);
      if (this.errorReserve && el.hasAttribute('data-armed')) el.style.minHeight = this.errorReserve + 'px';
    }

    /* The first press puts the error line in the flow with its reserve (see
       the header); it is never taken out again. */
    armError() {
      if (this.error.hasAttribute('data-armed')) return;
      if (!this.errorReserve) this.reserveError();
      this.error.setAttribute('data-armed', '');
      if (this.errorReserve) this.error.style.minHeight = this.errorReserve + 'px';
    }

    /* The drawer section, fetched the way assets/cart-drawer.js refreshes it,
       and painted through it, which also moves the header count. */
    async repaint() {
      const section = this.drawerSection();
      if (!section || typeof pp().paintCartSection !== 'function') return;
      const url = new URL(window.location.href);
      url.searchParams.set('sections', section);
      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      const data = res.ok ? await res.json() : null;
      if (data && data[section]) pp().paintCartSection(data[section]);
    }

    showError(text) {
      this.error.textContent = text;
    }

    clearError() {
      this.error.textContent = '';
    }
  }

  window.customElements.define('pp-paris-box', ParisBox);
})();
